import React from "react";
import { Route, Routes } from "react-router-dom";
import { ContentLayout } from "../components/contentLayout/contentLayout";
import { IMAGES } from "../constants/images";

// ROTAS
import { VerificacaoLogin } from "../pages/autenticacao/verificacao";

const styles = {
  containerCadastro: {
    backgroundImage: `url(${IMAGES.backgroundCadastro})`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
  },
};

const VerificacaoRoutes = () => {
  return (
    <ContentLayout style={styles?.containerCadastro}>
      <Routes>
        <Route path="*" element={<VerificacaoLogin />} />
      </Routes>
    </ContentLayout>
  );
};

export { VerificacaoRoutes };
